import { CalendarToday, Today } from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  SvgIcon,
  TextField,
} from "@mui/material";
import { STATUS } from "configs/constant";
import dayjs from "dayjs";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useMemo, useState } from "react";
import { Search as SearchIcon } from "../../../components/icons/search";
import useAuth from "../../../hooks/useAuth";
import { useCustomerUIContext } from "../CustomerUIContext";
import { initialFilter } from "../CustomerUIHelpers";

const initialValues = {
  customer_name: "",
};

const prepareFilter = (queryParams, values) => {
  const { customer_name } = values;
  const newQueryParams = { ...queryParams };
  const filter = {
    paramsCustomerName: customer_name,
  };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function CustomerToolbar() {
  const { isStrictAccess } = useAuth();
  const customerUIContext = useCustomerUIContext();
  const customerUIProps = useMemo(() => {
    return {
      queryParams: customerUIContext.queryParams,
      setQueryParams: customerUIContext.setQueryParams,
      goToCreateCustomer: customerUIContext.goToCreateCustomer,
      goToExportCustomer: customerUIContext.goToExportCustomer,
    };
  }, [customerUIContext]);
  const {
    queryParams,
    setQueryParams,
    goToCreateCustomer,
    goToExportCustomer,
  } = customerUIProps;

  const handleFormSubmit = (values) => {
    const newQueryParams = prepareFilter(queryParams, values);
    if (!isEqual(newQueryParams, queryParams)) {
      setQueryParams(newQueryParams);
    }
  };

  const handleToggleFilterTodayCleaning = () => {
    let filter = {
      filter: {
        start_cleaning_time: dayjs().format("YYYY-MM-DD"),
        end_cleaning_time: dayjs().format("YYYY-MM-DD"),
      },
      pageNumber: 1,
      pageSize: 500,
    };
    setQueryParams(filter);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatus = (status) => {
    if (anchorEl) {
      if (status === STATUS.NONE) {
        setQueryParams(initialFilter);
      } else {
        let filter = {
          filter: {
            status: status,
          },
          pageNumber: 1,
          pageSize: 500,
        };
        setQueryParams(filter);
      }
      setAnchorEl(null);
    }
  };

  const [anchorElMenu, setAnchorElMenu] = useState(null);
  const handleMenuOpen = (event) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorElMenu(null);
  };

  const [startCleaningTime, setStartCleaningTime] = useState("");
  const [endCleaningTime, setEndCleaningTime] = useState("");

  const handleApplyFilter = () => {
    const start = dayjs(startCleaningTime).format("YYYY-MM-DD");
    const end = dayjs(endCleaningTime).format("YYYY-MM-DD");

    let filter = {
      filter: {
        start_cleaning_time: start,
        end_cleaning_time: end,
      },
      pageNumber: 1,
      pageSize: 500,
    };

    setQueryParams(filter);
    handleMenuClose();
  };

  return (
    <Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          m: -1,
        }}
      >
        <h1 className="pages-title">
          <u>Data Pelanggan</u>
        </h1>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Box sx={{ m: 1 }}>
            <Button
              color="primary"
              variant="contained"
              onClick={goToCreateCustomer}
              startIcon={<AddCircleOutlineIcon />}
              title="Tambah Data Pelanggan"
            >
              Tambah Pelanggan
            </Button>
          </Box>
          {isStrictAccess && (
            <Box sx={{ m: 1 }}>
              <Button
                color="primary"
                variant="contained"
                onClick={goToExportCustomer}
                startIcon={<FileDownloadIcon />}
                title="Export Data Pelanggan"
              >
                Export Data
              </Button>
            </Box>
          )}
        </Grid>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Card>
          <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
            {({ handleSubmit, handleChange }) => (
              <form onSubmit={handleSubmit}>
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ maxWidth: 400 }}>
                    <TextField
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SvgIcon color="action" fontSize="small">
                              <SearchIcon />
                            </SvgIcon>
                          </InputAdornment>
                        ),
                      }}
                      placeholder="Cari Nama Pelanggan"
                      variant="outlined"
                      name="customer_name"
                      onChange={handleChange}
                      autoComplete="off"
                    />
                  </Box>
                  {isStrictAccess && (
                    <Box sx={{ display: "flex" }}>
                      <Box sx={{ m: 1 }}>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={handleClick}
                          startIcon={<FilterAltIcon />}
                          title="Filter Berdasarkan Status"
                        >
                          Status
                        </Button>
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                        >
                          <MenuItem onClick={() => handleStatus(STATUS.NONE)}>
                            {STATUS.NONE}
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleStatus(STATUS.REGISTERED)}
                          >
                            {STATUS.REGISTERED}
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              handleStatus(STATUS.DONE_TAKING_SCHEDULE)
                            }
                          >
                            {STATUS.DONE_TAKING_SCHEDULE}
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleStatus(STATUS.NOTIFICATION_H1)}
                          >
                            {STATUS.NOTIFICATION_H1}
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleStatus(STATUS.DONE_CLEANING)}
                          >
                            {STATUS.DONE_CLEANING}
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleStatus(STATUS.ALL_DONE)}
                          >
                            {STATUS.ALL_DONE}
                          </MenuItem>
                        </Menu>
                      </Box>
                      <Box sx={{ m: 1 }}>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={handleMenuOpen}
                          startIcon={<CalendarToday />}
                          title="Filter Berdasarkan Waktu Booking"
                        >
                          Waktu Booking
                        </Button>
                        <Menu
                          anchorEl={anchorElMenu}
                          open={Boolean(anchorElMenu)}
                          onClose={handleMenuClose}
                        >
                          <MenuItem>
                            <TextField
                              label="Start Cleaning Time"
                              type="date"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={startCleaningTime}
                              onChange={(e) =>
                                setStartCleaningTime(e.target.value)
                              }
                            />
                          </MenuItem>
                          <MenuItem>
                            <TextField
                              label="End Cleaning Time"
                              type="date"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={endCleaningTime}
                              onChange={(e) =>
                                setEndCleaningTime(e.target.value)
                              }
                            />
                          </MenuItem>
                          <MenuItem>
                            <Button
                              color="primary"
                              variant="contained"
                              sx={{ fontSize: "15px" }}
                              onClick={handleApplyFilter}
                            >
                              Aplikasikan Filter
                            </Button>
                          </MenuItem>
                          <MenuItem>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={handleToggleFilterTodayCleaning}
                              startIcon={<Today />}
                              title="Pilih Jadwal Disedot Hari Ini"
                              sx={{ bgcolor: "green" }}
                            >
                              Pilih Hari ini
                            </Button>
                          </MenuItem>
                        </Menu>
                      </Box>
                      <Box sx={{ m: 1 }}></Box>
                      <Box sx={{ m: 1 }}>
                        <Button
                          color="primary"
                          style={{
                            backgroundColor: "#FF5656",
                          }}
                          variant="contained"
                          onClick={() => {
                            setQueryParams(initialFilter);
                          }}
                          startIcon={<FilterAltOffIcon />}
                          title="Hapus Filter"
                        >
                          Hapus Filter
                        </Button>
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </form>
            )}
          </Formik>
        </Card>
      </Box>
    </Box>
  );
}
